import './QueryPills.css'

import React, { useState } from 'react'

import Button from '../Button/Button'
import Icon from '../Icon2'
import Pills from '../Pills/Pill'
import QueryPillsV2 from './QueryPillsV2'

export type QueryPillsProps = {
	testId?: String
	onClearAllFilters?: Function
	filterPillsArr?: any
	onPillsCancelClick?: Function
	onHideFilterClick?: Function
	version?: 'v1' | 'v2'
}
const QueryPills = (props: QueryPillsProps) => {
	const { testId = "cs-query-pills", onClearAllFilters, filterPillsArr, onPillsCancelClick, onHideFilterClick, version } = props


	const [hideFilters, setHideFilters] = useState(false)

	const onHideFilters = () => {
		setHideFilters(!hideFilters)
		onHideFilterClick && onHideFilterClick(!hideFilters)
	}

	return filterPillsArr.length > 0 ? (
		<div data-test-id={testId} className="QueryPills">
			<div
				className={`QueryPills__filter-pills ${version} flex ${hideFilters ? 'QueryPills__filter-pills--hide' : 'QueryPills__filter-pills--show'
					}`}>
				{version === "v2" ? <QueryPillsV2 {...props} canTruncate={true} /> : (<>
					{
						filterPillsArr.map((pillsObj, i) => {
							return (
								<Pills
									status="default"
									isSingleton
									key={i}
									variant="label"
									shouldHaveBorder={false}
									stroke=""
									canTruncate={true}
									testId={`${testId}-item-${i}`}
									items={[
										{
											id: i,
											text: `${pillsObj.field} ${pillsObj.operator} ${pillsObj.value}`,
											trailingIcon: (
												<Icon
													icon="CloseNoborder"
													version="v2"
													size="extraSmall"
													onClick={(e) => onPillsCancelClick(e, pillsObj)}
													testId={`${testId}-item-${i}-cancel`}
												/>
											)
										}
									]}
								/>
							)
						})
					}
				</>)}
			</div>
			<div className="QueryPills__actions flex-justify">
				<Button
					version="v2"
					buttonType="tertiary"
					iconAlignment="right"
					onClick={onClearAllFilters}
					testId={`${testId}-clear-all`}
					size="small"
				>
					{`Clear All Filters (${filterPillsArr?.length})`}
				</Button>
				<Button
					version="v2"
					buttonType="tertiary"
					iconAlignment="right"
					icon="v2-CaretCircleRight"
					className={` ${hideFilters ? 'QueryPills__actions--hide' : 'QueryPills__actions--visible'}`}
					onClick={onHideFilters}
					testId={`${testId}-${hideFilters ? 'show' : 'hide'}-filters`}
					size="small"
				>
					{`${hideFilters ? 'Show' : 'Hide'} All Filters`}
				</Button>
			</div>
		</div>
	) : null
}

export default QueryPills
